export const METAL_OVERHANG_KEY = {
	WITH: window.btoa('with_overhang_metal'),
	WITHOUT: window.btoa('no_overhang_metal'),
};

export const METAL_OVERHANG_GROUP_KEY = 'roof_metal_overhang';

export const LEGACY_EXTRA_ROOF_DEPTH = new Map([
	['barn|barn_inner', 0.3],
	['barn|structure_barn_kloterfarms', 0.3],
	['lean_to|lean_to_add_extra_fascia_metal_trim', 0],
	['standard_cottage|structure_capecod_customfasicatrim_roofpitch_10_12', 0.32],
	['standard_cottage|structure_capecod_customfasicatrim_roofpitch_5_12', 0.32],
	['structure_aframe_middle_porch|structure_aframe_middle_porch', 0],
	['structure_alpinechalet|structure_alpinechalet', 0.43],
	['structure_capecod|structure_capecod_customfasicatrim_roofpitch_10_12', 0.32],
	['structure_capecod|structure_capecod_customfasicatrim_roofpitch_5_12', 0.32],
	['structure_capecod|structure_capecod_greenacres', 0.32],
	['structure_capecod|structure_capecod', 0.32],
	['structure_capecod|structure_capecod_3_12_pitch', 0.32],
	['structure_capecod|structure_capecod_6_12_pitch', 0.32],
	['structure_capecod|structure_capecod_7_12_pitch', 0.32],
	['structure_capecod|structure_capecod_allstor', 0.32],
	['structure_capecod|structure_capecod_customfasicatrim', 0.32],
	['structure_capecod|structure_capecod_timberframe', 0.32],
	['structure_capecod|structure_capecod_update_roof_component', 0.32],
	['structure_chalet_genesis|structure_chalet_genesis', 0],
	['structure_saltbox_mwshed|structure_saltbox_mwshed_inner', 0.3],
	['windsor|structure_windsor_3_12', 0.32],
	['windsor|structure_windsor_5incornertrim', 0.32],
	['windsor|structure_windsor_5infascia', 0.32],
	['windsor|structure_windsor_separate_fasciakey', 0.32],
	['windsor|structure_windsor_straight_roof_edge', 0.32],
	['windsor|structure_windsor_with_horizontal_trim_6in_bellyband', 0.32],
	['windsor|windsor', 0.32],
	['windsor|windsor_inner', 0.32],
	['windsor|windsor_removefasicatrimonsides', 0.32],
	['windsor|windsor_separate_trim', 0.32],
	['windsor|windsor_removedshinglespe', 0.32],
	['mainus_quaker|mainus_quaker', 0.32],
	['structure_trading_post|structure_trading_post', 0],
	['structure_trading_post|structure_trading_post_changetrimcolor', 0],
	['structure_trading_post|structure_trading_post_changetrimcolor_separate_keymat', 0],
]);
